import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { FormSelect, useWatch, useZionFormContext } from '@fs/zion-form'

export const NAME = 'guests'
export const DEFAULT_GUESTS = '1'
const MAX_GUESTS = 10

export function GuestsField({ disabled }) {
  const [t] = useTranslation()
  const { setValue } = useZionFormContext()
  const value = useWatch({ name: NAME })

  // `Select` requires string option values, and the submitted value comes back off the
  // native select as a string regardless, so keep both sides string-typed.
  const guestsNumber = Array.from({ length: MAX_GUESTS }, (_, i) => ({
    value: `${i + 1}`,
    label: `${i + 1}`,
  }))

  useEffect(() => {
    if (!value) setValue(NAME, DEFAULT_GUESTS)
  }, [setValue, value])

  return (
    <FormSelect
      name={NAME}
      label={`${t('form.field.guests.label', 'Number of Guests')}: *`}
      options={guestsNumber}
      disabled={disabled}
      // Select renders a selectable blank placeholder option by default; with a default
      // value of "1" it exists only to let the user pick an empty state the effect
      // immediately overwrites, which reads as the field jumping back on its own.
      hidePlaceholder
      required
    />
  )
}
